/**
 * Avatar Gadgets
 *
 * Small accessories layered ON TOP of the avatar (hat, glasses, pet, etc.) —
 * rendered as an overlay in the same stack as the avatar frame. Earned-only:
 * acquired via challenges and surprise-box drops, never bought.
 *
 * Ships as an EMPTY catalog until real gadget assets land (per the
 * no-fabrication rule — see CHALLENGES_SYSTEM.md §5.2). The data model, equip
 * slot, overlay render path (AvatarFrame), and box/challenge grantability are
 * all in place, so adding an entry below (plus its CSS class in
 * avatarGadgets.css) makes it immediately ownable, equippable, and droppable.
 */

import type { Rarity, Acquisition } from './rarity';

export interface AvatarGadget {
  id: string;
  name: string;
  description: string;
  /** Box dust/refund value — gadgets are earned-only, never purchased. */
  price: number;
  rarity: Rarity;
  /** Always 'earned' for gadgets (challenge rewards / box drops). */
  acquisition?: Acquisition;
  /** CSS class for the overlay layer; styling lives in avatarGadgets.css. */
  cssClass: string;
  /** Accent color used for swatches / fallback rendering. */
  swatchColor: string;
}

// Empty until real assets land.
export const AVATAR_GADGETS: AvatarGadget[] = [];

export function getAvatarGadget(id: string | undefined): AvatarGadget | null {
  if (!id) return null;
  return AVATAR_GADGETS.find(g => g.id === id) ?? null;
}
